<template>
    <v-row class="mt-10 fill-height primary">
      <v-col cols="12" class="pa-0">
        <v-row class="py-12 my-12 px-5">
          <v-col cols="12" md="12" class="pt-0" TRANSACTIONS>
            <v-row>

              <v-col cols="12" md="3" class="py-0 my-0" PANNELS>
              </v-col>
              <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} white--text text-center` ">
                <h3>أنت في المكان الصحيح.. مع نينجا سيلرز يمكنك توديع البطالة والخوف من الفشل وتأجيل أحلامك.. ابدأ بتحقيق الأرباح في مجال التجارة الإلكترونية في بيئة آمنة ومضمونة مع نينجا سيلرز ومأمون الصباغ خبير في التجارة الالكترونية ومؤسس لعدد من الشركات في المجال.. هل أنت مستعد لبناء مشروع العمر الخاص بك؟</h3>
              </v-col>
              <v-col cols="12" md="3" class="py-0 my-0" PANNELS>
              </v-col>

              

              <v-col cols="12" md="2" class="py-0 my-0" PANNELS>
              </v-col>
              <v-col cols="12" md="8" :class="`${arabic?'arFont':'enFont'} white--text text-center` " v-if="false">
                <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/756118698?h=6fcc61a95f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="هل تريدُ أن  تحققَ الأرباحَ مِنْ خلالِ التجارةِ الالكترونيةِ بشكلٍ دوريٍ ومضمونٍ  ؟"></iframe></div>
              </v-col>
              <v-col cols="12" md="8" :class="`${arabic ? 'arFont' : 'enFont'} white--text text-center`">
                <iframe width="100%" style="max-width:560px;" height="315" src="https://www.youtube.com/embed/wcC1RPuRLFw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </v-col>
                <v-col cols="12" md="2" class="py-0 my-0" PANNELS>
              </v-col>

              <v-col cols="12" md="3" class="py-0 my-0" PANNELS>
              </v-col>
              <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} white--text text-center` ">
                <v-btn color="success" x-large @click="goToLink()">ابدأ الان</v-btn>
                <v-card color="secondary" dark class="py-3 my-5">
                  <h1>
                    تعلم التجارة الالكترونية مجانا استغل الفرصة الان
                  </h1>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" class="py-0 my-0" PANNELS>
              </v-col>

              <v-col cols="12" md="3" PANNELS>
              </v-col>
              <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} white--text text-center` ">
                <h4>
                  ملاحظة لا داعي لحجز استشارة بعد الان فقد تم عمل محتوى على يد مأمون الصباغ و فريق نينجا سيلرز و شكل كل ما تحتاج لتعلم التجارة الالكترونية و ايضا كل شيء خاص بمنصة نينجا سيلرز مع نينجا سيلرز الشريك الذي يجعل حلمك حقيقة
                </h4>
                <v-btn color="success" class="my-3" x-large @click="goToLink()">ابدأ الان</v-btn>
              </v-col>
              <v-col cols="12" md="3" PANNELS>
              </v-col>
            
              <v-col cols="12" md="1" PANNELS>
              </v-col>
              <v-col cols="12" md="10" PANNELS v-if="false">
                <v-card color="white" class="pa-3 pt-8" :loading="loading" style="height:800px;">
                  <v-card-text class="text-center" style="height:800px;" id="form">
                    <!-- Calendly inline widget begin -->
                    <div class="calendly-inline-widget" hide_gdpr_banner="1" data-url="https://calendly.com/ninjasellers/30min?primary_color=be202e&hide_gdpr_banner=1" style="min-width:320px;height:630px;"></div>
                    <!-- Calendly inline widget end -->
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="1" PANNELS>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
</template>
<script>
import Search from '@/components/Search'
export default {
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      verify_success:false,
      newResource:{},
      editing:false,
      deleting:false,
    }
  },
  methods: {
    goToLink() {
      window.location.href = 'https://academy.ninjasellers.com/'
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
      Calendly.initInlineWidget({
      url: 'https://calendly.com/ninjasellers/30min?primary_color=be202e',
      parentElement: document.getElementById('calendly-inline-widget'),
      prefill: {},
      utm: {}
    });
    
  },
  mounted() {
    let k = '.onetrust-close-btn-handler'
    document.querySelector(k).click()
  }
}
</script>

<style>
#onetrust-banner-sdk,
#onetrust-banner-sdk *,
#onetrust-consent-sdk,
#onetrust-consent-sdk * {
  display:none !important;
  visibility: hidden;
}
</style>